import React from 'react'
import './styles/treatments-template.css'
import ReactMarkdown from 'react-markdown'


export default function TreatmentsTemplate(props) {

    const stylesHero = {
        backgroundImage: `url(${props.backgroundImage})`,
        backgroundPosition: 'center', 
        backgroundSize: 'cover',
        height: '500px',
        width: '100%',
    }
    return (
        <div>
            <header style={stylesHero}  className='tra-component'>
                <div className="hero-container">
                    <h2>{props.title}</h2>
                    <hr/>
                    <p>{props.paragraph}</p>
                </div>
            </header>
            <section>
                <div className={`text-content`, props.addClass}>
                    <ReactMarkdown source={props.mediaContent}/>
                </div>
            </section>
        </div>
    )
}
